import { NgStyle } from '@angular/common';
import { HttpErrorResponse } from '@angular/common/http';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { Subscription } from 'rxjs';
import { action } from 'src/app/interfaces/action';
import { CardView } from 'src/app/interfaces/cardview';
import { DialogService } from 'src/app/services/dialog.service';
import { HTTPService } from 'src/app/services/http.service';
import { SnackbarService } from 'src/app/services/snackbar.service';
import { ObjectUtil } from 'src/app/system-utils/utils/ObjectUtil';
import { CustomActionParametersComponent } from '../../simple-datagrid/custom-action-parameters/custom-action-parameters.component';
import { flowData } from 'src/app/interfaces/flowData';
import { FlowModalComponent } from '../../flow-action/flowaction.component';

@Component({
    selector: 'cardview',
    templateUrl: './cardview.component.html',
    styleUrls: ['./cardview.component.scss'],
    standalone: false
})
export class CardviewComponent implements OnInit {

  @Input()cardrow:CardView;
  @Input()options:Object[] = [];
  @Input()tableName:string = "";
  @Output() tableContextmenu: EventEmitter<any> = new EventEmitter();
  @Output() action: EventEmitter<any> = new EventEmitter();
  @Input() userConfig:object;
  tileStyle: NgStyle;  
  sub:Subscription;
  constructor(sanitazer:DomSanitizer,private dialog:DialogService, private http:HTTPService, private snackBar:SnackbarService, private dialogServices:DialogService ) { }


  ngOnDestroy(){
      if ( this.sub!= null ){this.sub.unsubscribe();}
  }

  ngOnInit() {
      
      

  }

  onClick(event:Event){
    event.preventDefault();
    event.stopPropagation();
    event.stopImmediatePropagation();
  }


  executeCustomAction(action:action, parameters:string, choose:Boolean = false){

    
    this.sub = this.http.executeBackEndAction(this.tableName, action, [this.cardrow.linha], parameters,choose ).subscribe(sucesso=>{
       let mensagens:string[] = sucesso['mensagens'];
       
       let mensagemFinal:string = "";
       if ( ObjectUtil.isNotEmpty(mensagens)){
          mensagens.forEach(mensagem=>{
            mensagemFinal = mensagemFinal + mensagem + "\n\r"
         })

         this.snackBar.showSuccess(mensagemFinal);
       }else{
        this.snackBar.showSuccess("Ação executada com sucesso.");
       }

       this.action.emit(true);
       
    },exception=>{
      
        if ( exception instanceof HttpErrorResponse ){

            if ( ObjectUtil.isNotEmpty(exception.error) && ObjectUtil.isNotEmpty(exception.error.message)){

              if ( (exception.error.message as String).indexOf("__CHOOSE__N__S__")>-1){
                  let title = exception.error.message.split("__")[2];
                  this.dialogServices.openNewDialog(title,(data)=>{
                    this.executeCustomAction(action,parameters, true);
                  },(data)=>{
                      this.snackBar.showInformation("Processo cancelado pelo usuário.");
                  });
              }else{
                throw exception;
              }

            }else{
              throw exception;
            }
        
        }else{
          throw exception;
        }
      
    });

}

  callCustomAction(item:object, event:Event){

    let action = item['action'];
    
    if ( action.TYPE === "P" || action.TYPE==="J" || action.TYPE==="F"){

        if ( action.PARAMETERS != null && action.PARAMETERS.length > 0 ){
            this.dialogServices.openGenericDialog(CustomActionParametersComponent, action.PARAMETERS,(data)=>{
      
              this.executeCustomAction(action,data);
            })
        }else{
          this.executeCustomAction(action,null);
        }
    }else if(action.TYPE == "C"){
      
      if (action.PARAMETERS != null && action.PARAMETERS.length > 0) {
        this.dialogServices.openGenericDialog(
          CustomActionParametersComponent,
          action.PARAMETERS,
          (data) => {
            //this.executeCustomAction(action, data);
            openFlowData(data, this);
          }
       );
      }else{
        openFlowData(null, this);

      }        

     } else{
       throw ("Não implementado a ação Angular.")
     }
    

    function openFlowData(parameters, self) {
      let flowData: flowData = {
        selected: self.cardrow.linha,
        function: null,
        action: action,
        parameters: parameters
      };

      self.dialogServices.openGenericDialog(
        FlowModalComponent,
        flowData,
        (data) => {
        }
      );
    }
  }


  openDialog(event:Event,ob:Object){
    
    if ( ob['type'] == "action"){
        this.callCustomAction(ob,event);
    }else{
      if ( ObjectUtil.isNotEmpty(ob['component'])){
        if ( ob['action']){
          (ob['action'] as Function).call(this,'editando',this.userConfig, this.cardrow.linha)
        }else{
          this.dialog.openGenericDialog(ob['component'] as Component,{cardRow: this.cardrow, options:ob },(data)=>{ 
          },()=>{},'80vh','100vw',false,null,'S','80px')  
        }
        
        
      }
    }
    
  }


  eventHandle(event:Event){
    
    var element =  (event.target as Element);
    var value = element.innerHTML;
    let field:string = value.replace(":","");

    this.tableContextmenu.emit(this.cardrow.table.find(card=>{
      return card.descName == field;
    }))
  }
}
